import { Button, MenuItem, TextField } from '@mui/material'
import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { useStyles } from './styles'

interface IFilter {
  search: string
  status: string
}

interface CustomerListFilterProps {
  filter: IFilter
  onChangeFilter: Dispatch<SetStateAction<IFilter>>
  onClear: () => void
}

const CustomerListFilter = ({ filter, onChangeFilter, onClear }: CustomerListFilterProps) => {
  const classes = useStyles()

  const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeFilter((prev) => ({
      ...prev,
      search: e.target.value,
    }))
  }

  const handleChangeStatus = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeFilter((prev) => ({
      ...prev,
      status: e.target.value,
    }))
  }

  return (
    <div className={classes.root}>
      <div className={classes.filter}>
        <TextField
          size='small'
          label='Pesquisar'
          placeholder={'Pesquisar por nome ou CNPJ'}
          type='text'
          variant='outlined'
          value={filter.search}
          sx={{ width: '280px' }}
          onChange={handleChangeSearch}
        />

        {/* <TextField
          id='automacoes'
          value={'Todos'}
          label='Automações'
          defaultValue='Todos'
          sx={{ width: '280px' }}
          select
        >
          <MenuItem value={'Todos'}>Todos</MenuItem>
        </TextField> */}

        <TextField
          select
          id='status'
          value={filter.status}
          label='Status'
          onChange={handleChangeStatus}
          defaultValue='Todos'
          sx={{ width: '280px' }}
          size='small'
        >
          <MenuItem value='Todos'>Todos</MenuItem>
          <MenuItem value='Convite Expirado'>Convite Expirado</MenuItem>
          <MenuItem value='Convite Enviado'>Convite Enviado</MenuItem>
          <MenuItem value='Pendente'>Pendente</MenuItem>
          <MenuItem value='Ativo'>Ativo</MenuItem>
        </TextField>
      </div>

      <Button
        variant='contained'
        color='primary'
        size='small'
        onClick={onClear}
        sx={{ padding: '1rem', height: '2.5rem' }}
        disabled={filter.search === '' && filter.status === 'Todos'}
      >
        Limpar Filtro
      </Button>
    </div>
  )
}

export default CustomerListFilter
